import EventEmitter from 'ts-event-emit'

export type AllowedEvents =
    | 'PRODUCT_ADDED_TO_CART'
    | 'PRODUCT_REMOVED_FROM_CART'
    | 'QUICK_ADD_TO_CART'
    | 'TOGGLE_CART_DRAWER'
    | 'FLY_TO_CART'
    | 'SHOW_WIP_MODAL'
    | 'REFRESH_CONTEXT'
    | 'CLOSE_MOBILE_MENU'

const eventEmitter = new EventEmitter<AllowedEvents>()

export default eventEmitter
